export const initDshopProdcut = (product = {}) => ({
    ...product,
    _category: product?._category || null,
    _mainProduct: product?._mainProduct || null,

    name: product?.name || null,
    code: product?.code || null,
    type: product?.type || "main",
    info: product?.info || [],
    optionalNames: product?.optionalNames || [],
    optionalValues: product?.optionalValues || [],

    content: product?.content || null,
    mobileContent: product?.mobileContent || null,

    stock: product?.stock || 0,
    costPrice: product?.costPrice || 0,
    salePrice: product?.salePrice || 0,
    discountUnit: product?.discountUnit || 'won',
    discountAmount: product?.discountAmount || 0,
    isTaxFree: product?.isTaxFree || false,

    thumb: product?.thumb || null,
    images: product?.images || [],

    soldout: product?.soldout || false,
    onSale: product?.onSale ?? true,
    onDisplay: product?.onDisplay ?? true,

    isBest: product?.isBest || false,
    isRecommend: product?.isRecommend || false,
    isNewly: product?.isNewly || false,
    isPopular: product?.isPopular || false,
    isDeduction: product?.isDeduction || false,
    isMain: product?.isMain || false,
})